'use client';

import React from 'react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {setQueryClient} from '@framework/utils/http';

function Providers({ children }: React.PropsWithChildren) {
  const queryClientRef = React.useRef<any>();
  if (!queryClientRef.current) {
    queryClientRef.current = new QueryClient({
      defaultOptions: {
        queries: {
          retry: 3,
          staleTime: 5 * 60 * 1000, // 5 minutes cache
        }
      }
    });
    // Set the query client instance for the HTTP interceptor
    setQueryClient(queryClientRef.current);
  }

  return (
    <QueryClientProvider client={queryClientRef.current}>
      {children}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}

export default Providers;
